function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectionCards = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _SelectionCard = require("./SelectionCard");
var _FieldSet = require("../FieldSet");
var _View = require("../View");
var _styles = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "style", "legend", "showLegend"],
  _excluded2 = ["items", "onSelect", "isMulti", "selectedIds"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var Container = (0, _react.memo)(function (_ref) {
  var children = _ref.children,
    style = _ref.style,
    legend = _ref.legend,
    showLegend = _ref.showLegend,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    bp = _STYLES$useStyles.bp;
  return (0, _jsxRuntime.jsx)(_FieldSet.FieldSet, Object.assign({
    style: style,
    testID: "SelectionCards",
    legend: legend != null ? legend : '',
    showLegend: showLegend
  }, props, {
    children: (0, _jsxRuntime.jsx)(_View.View, {
      spacer: bp.desktop ? spacing.normal : spacing.s,
      children: children
    })
  }));
});
var SelectionCards = exports.SelectionCards = (0, _react.memo)(function (_ref2) {
  var items = _ref2.items,
    onSelect = _ref2.onSelect,
    _ref2$isMulti = _ref2.isMulti,
    isMulti = _ref2$isMulti === void 0 ? false : _ref2$isMulti,
    selectedIds = _ref2.selectedIds,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var _onSelect = function _onSelect(id) {
    var _newIds = JSON.parse(JSON.stringify(selectedIds || []));
    var _idIndex = _newIds.indexOf(id);
    if (_idIndex > -1) {
      _newIds.splice(_idIndex, 1);
    } else {
      if (!isMulti) {
        _newIds.length = 0;
      }
      _newIds.push(id);
    }
    onSelect == null ? void 0 : onSelect(_newIds);
  };
  return (0, _jsxRuntime.jsx)(Container, Object.assign({}, props, {
    children: items == null ? void 0 : items.map(function (item) {
      var _isSelected = (selectedIds == null ? void 0 : selectedIds.includes(item.id)) || false;
      return (0, _react.createElement)(_SelectionCard.SelectionCard, Object.assign({}, item, {
        onSelect: _onSelect,
        selected: _isSelected,
        key: item.id
      }));
    })
  }));
});